/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S3_IntroInputs */

const tr_iletisim_s3_intro = /** @type {(inputs: Iletisim_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kişisel verilerinize ilişkin KVKK Madde 11 kapsamındaki talepler için:`)
};

const en_iletisim_s3_intro = /** @type {(inputs: Iletisim_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For requests regarding your personal data under KVKK Article 11:`)
};

const de_iletisim_s3_intro = /** @type {(inputs: Iletisim_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Anträge nach Artikel 11 KVKK zu Ihren personenbezogenen Daten:`)
};

const ru_iletisim_s3_intro = /** @type {(inputs: Iletisim_S3_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По запросам в отношении ваших персональных данных в рамках статьи 11 KVKK:`)
};

/**
* | output |
* | --- |
* | "For requests regarding your personal data under KVKK Article 11:" |
*
* @param {Iletisim_S3_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s3_intro = /** @type {((inputs?: Iletisim_S3_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S3_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s3_intro(inputs)
	if (locale === "de") return de_iletisim_s3_intro(inputs)
	if (locale === "ru") return ru_iletisim_s3_intro(inputs)
	return tr_iletisim_s3_intro(inputs)
});